var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendFeedback(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 164 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M88.3294 19.6245C82.3078 16.1844 75.3244 17.5716 69.4517 20.1574C51.0037 28.2821 38.3485 46.5976 28.5737 65.6625C25.034 72.5633 21.7185 79.82 20.7356 87.9086C18.7275 104.374 27.8332 122.86 41.8159 130.735C46.5741 133.413 51.7116 134.931 56.8299 136.059C65.934 138.077 75.2838 138.952 84.0637 136.978C90.3244 135.565 96.1539 132.74 101.71 129.504C117.237 120.465 131.14 107.919 140.694 91.6397C144.879 84.4845 148.29 76.2684 147.841 67.345C147.391 58.4216 142.109 48.8292 134.258 46.3082C131.011 45.2653 127.66 45.4799 124.395 45.7263C119.585 46.0882 114.713 46.4926 109.868 45.4316C104.865 44.337 98.2381 41.1104 96.9702 35.119C95.6067 28.6902 94.3454 23.0668 88.3294 19.6245Z",
    fill: "#039BE5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#269643ea-477a-4850-86a1-0d18385bb1c3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1455 87.4544L39.4471 71.9342L80.4328 42.6427L121.419 71.9342L107.501 87.4544H53.1455Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1455 87.4544L39.4471 71.9342L80.4328 42.6427L121.419 71.9342L107.501 87.4544H53.1455Z",
    fill: "#514ABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.446 73.9016H39.4471V108.767H119.446V73.9016Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.446 73.9016H39.4471V108.767H119.446V73.9016Z",
    fill: "url(#e7fb22a8-5d74-4e4c-a397-679acac555c6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.4955,
    y: 71.5364,
    width: 57.5781,
    height: 32.2786,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.419 121.227H39.4471V71.9343L80.4328 96.6353L121.419 71.9343V121.227Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7926 60.8823L39.4667 61.041L39.5042 60.9746L39.4756 60.9838L39.5157 60.9541L43.9022 53.1687L46.1444 55.0755L48.068 56.8517L47.5157 57.1207L48.1366 58.213L39.7926 60.8823Z",
    fill: "url(#b8986aca-284b-435a-8a39-fbe9d17d07f1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9223 55.2792L47.6805 56.9051L39.7113 60.8565L43.9522 55.4354L45.9223 55.2792Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M45.9223 55.2792L47.6805 56.9051L39.7113 60.8565L43.9522 55.4354L45.9223 55.2792Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8715 53.5352L39.7113 60.8566L45.9223 55.2793L43.8715 53.5352Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7318 58.1639L39.7198 60.8034L46.4173 55.8172L47.7318 58.1639Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.729 46.8757L112.974 49.9108L125.844 52.0009L117.555 46.2439L114.729 46.8757Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M114.729 46.8757L112.974 49.9108L125.844 52.0009L117.555 46.2439L114.729 46.8757Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.843 43.5491L125.844 52.0009L114.729 46.8758L116.843 43.5491Z",
    fill: "#037DBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.449 51.6948L125.809 51.9303L114.27 47.8426L113.449 51.6948Z",
    fill: "#037DBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e7fb22a8-5d74-4e4c-a397-679acac555c6",
    x1: 79.4466,
    y1: 108.767,
    x2: 79.4466,
    y2: 73.9016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55135,
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b8986aca-284b-435a-8a39-fbe9d17d07f1",
    x1: 45.9695,
    y1: 60.7488,
    x2: 41.0315,
    y2: 56.5273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53514,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "269643ea-477a-4850-86a1-0d18385bb1c3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.3969,
    height: 78.5844,
    fill: "white",
    transform: "translate(39.4471 42.6427)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFeedback);
export default __webpack_public_path__ + "static/media/sendFeedback.9c976b51.svg";
export { ForwardRef as ReactComponent };